import axios from 'axios';

const KASASA_CASH_SHORTNAME = 'cash';
const KASASA_CASH_EDGE_PRODUCT_TYPE = 'KASASA_CASH_EDGE';
const KASASA_CASH_BACK_EDGE_PRODUCT_TYPE = 'KASASA_CASH_BACK_EDGE';

const getProductMappingInformation = (fiId: string, productShortname: string): Promise<any> =>  {
    let productMappingGetUrl;
    if (productShortname === KASASA_CASH_SHORTNAME) {
        productMappingGetUrl = '/api/rcx/config/' + fiId + '/product-mapping/product-types/' + KASASA_CASH_EDGE_PRODUCT_TYPE;
    } else {
        productMappingGetUrl = '/api/rcx/config/' + fiId + '/product-mapping/product-types/' + KASASA_CASH_BACK_EDGE_PRODUCT_TYPE;
    }
    return axios.get(productMappingGetUrl);
 }

export {
    getProductMappingInformation,
}
